const env = import.meta.env as Record<string, string | undefined>;

const requireEnvVar = (key: string): string => {
  const value = env[key]?.trim();
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
};

export const SESSION_PRICE_INTRO = requireEnvVar("VITE_SESSION_PRICE_INTRO");
export const SESSION_PRICE_ONLINE = requireEnvVar("VITE_SESSION_PRICE_ONLINE");
export const SESSION_PRICE_PRESENCE = requireEnvVar("VITE_SESSION_PRICE_PRESENCE");
